export const FETCH_AUTHS_PENDING = 'FETCH_AUTHS_PENDING';
export const FETCH_AUTHS_SUCCESS = 'FETCH_AUTHS_SUCCESS';
export const FETCH_AUTHS_ERROR = 'FETCH_AUTHS_ERROR';